import React, {Component} from 'react';
import trocaSenhaImg from "../img/troca-senha.png";
class ValidacaoBrowser extends Component { 
  render() {
    return (
    <div className="container">
      <div className="row">
        <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
          <h5 className="card-title text-center margin-top">
            <img src={trocaSenhaImg} className="img-responsive troca-senha" alt="Imagem responsiva" />
          </h5>
          <div className="msg center">Recomendado o uso dos navegadores <br /><b>Google Chrome</b> ou <b>Mozilla Firefox</b>.</div>
        </div>
      </div>
    </div>
    );
  }
}

export default ValidacaoBrowser